import React from 'react'

const ExamSetUp = () => {
  return (
    <div>Exam SetUp</div>
  )
}

export default ExamSetUp